import Vue from 'vue/dist/vue.esm'
import VueRouter from 'vue-router'

import Round1 from '@/pages/Round1.vue'
import Round2 from '@/pages/Round2.vue'
import Error404 from '@/pages/404.vue'
import Complaint from '@/pages/Complaint.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/404',
      component: Error404
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/file-your-claim',
      component: Round1,
      name: 'round1',
      props: function(route) {
        const sourceOriginParam = route.query['source-origin'] || route.query['source_origin'] || route.query['utm_source'];
        return {
          source_origin: route.path === "/GF-forsikring/anmeld-krav/" ? "gf_insurance" : sourceOriginParam,
          arr_apt: route.query['arr_apt'],
          dep_apt: route.query['dep_apt'],
          tduid: route.query['tduid'],
          pc_guid: route.query['pc_guid'],
        };
      },
      alias: [
        '/GF-forsikring/anmeld-krav/',
        '/anmeld-krav',
        '/gor-anmalan',
        '/wyslij-zgloszenie',
        '/anmeld-sak',
        '/kontaktformular',
        '/toimita-hakemus',
        '/vznest-narok',
        '/talepte-bulunun'
      ]
    },
    {
      path: '/authorizations/:key',
      component: Round2,
      name: 'round2'
    },
    {
      path: '/authorizations/:key/complaint',
      component: Complaint,
      name: 'complaint'
    }
  ]
});

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
